export interface LatestPostProps {
  image: string
  title: string
  link: string
  date: string
}

export const useLatestPost = (props: LatestPostProps) => {
  return {
    ...props,
  }
}
